import { render, staticRenderFns } from "./UploadDXF.vue?vue&type=template&id=6412b5c2&scoped=true"
import script from "./UploadDXF.vue?vue&type=script&lang=js"
export * from "./UploadDXF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6412b5c2",
  null
  
)

export default component.exports